var _circle, _ellipse, _ellipse2, _path, _path2, _polygon, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle3, _circle4, _circle5, _circle6, _circle7, _path20, _path21, _polygon2, _polygon3, _path22, _ellipse3, _path23, _path24, _circle8, _path25, _path26, _path27, _polygon4, _polygon5, _path28, _ellipse4, _path29, _path30, _circle9, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bcdff026-9b21-4da7-924c-007c0e295dcb",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 921.67049,
    height: 831.29516,
    viewBox: "0 0 921.67049 831.29516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "privacy_protection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 436.46932,
    cy: 576.55581,
    r: 216.46236,
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.89011,
    cy: 803.23377,
    rx: 205.41211,
    ry: 28.06139,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 550.93528,
    cy: 262.3079,
    rx: 14.54025,
    ry: 7.05806,
    transform: "translate(-194.02831 154.86044) rotate(-18.57978)",
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.45984,294.47867l76.27461-34.75382S726.95654,210.88119,837.5,330.10945c0,0-49.54223-31.8027-87.09376,10.207,0,0-70.66206-19.1171-129.961,51.12411,0,0-92.74716,14.04481-131.3753,63.26528,0,0-43.06382-6.62283-60.20459,47.97007a1.6372,1.6372,0,0,1-2.70874.67441h0a1.62664,1.62664,0,0,1-.46047-.85878C424.08674,494.05426,405.14671,381.5055,521.45984,294.47867Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521.45984,294.47867l76.27461-34.75382S726.95654,210.88119,837.5,330.10945c0,0-49.54223-31.8027-87.09376,10.207,0,0-70.66206-19.1171-129.961,51.12411,0,0-92.74716,14.04481-131.3753,63.26528,0,0-43.06382-6.62283-60.20459,47.97007a1.6372,1.6372,0,0,1-2.70874.67441h0a1.62664,1.62664,0,0,1-.46047-.85878C424.08674,494.05426,405.14671,381.5055,521.45984,294.47867Z",
    transform: "translate(-139.16475 -34.35242)",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "405.524 404.125 437.285 409.419 447.872 359.13 422.287 348.543 405.524 404.125",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.19566,
    cy: 366.62921,
    r: 27.34998,
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M576.44995,416.42113s2.64677,33.52578-17.64515,36.17255,17.64515,62.64026,27.35,61.758,27.35-65.287,27.35-65.287S590.56606,433.184,598.50638,419.0679Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M542.483,538.61376s3.529,25.58546,14.11612,25.58546-7.05806-29.11449-7.05806-29.11449Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M696.87806,564.19922s26.46772,22.05643,22.93869,29.11449-26.46772-7.94031-28.23223-25.58546Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M537.1895,648.89592l-16.76289,62.64026-18.5274,75.87413h17.64514s6.1758-23.82095,17.64515-36.17255c0,0,11.46934-19.40966,11.46934-32.64352l27.35-64.40478Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M609.53459,652.425l5.29355,59.11123s-.88226,42.34835,0,52.05318,0,23.82095,0,23.82095h15.88063s14.99837-52.05318,10.58708-80.28541l6.1758-66.1693Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M588.36042,490.08961s-23.77-18.83744-17.61966-45.15014c0,0-23.84643,1.03728-33.55126,10.74211s2.64677,42.34835,2.64677,42.34835,21.17417,35.29029,17.64514,51.17092-41.46609,99.69507-29.11449,104.98861,87.34347,23.82095,125.28054-7.05806c0,0,9.70483-87.34347-29.11449-115.5757V509.49927s7.058-6.1758,3.529-22.05643c0,0,14.99838-27.35,6.17581-32.64352s-29.0887-13.05117-29.0887-13.05117S606.88782,481.267,588.36042,490.08961Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M542.483,455.68158S531.0137,453.91706,519.54435,470.68s-41.46609,43.23061-27.35,56.46447,52.05318,22.05643,52.05318,22.05643l8.82257-15.88063-37.93706-18.52741,31.76126-23.82094Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M629.82651,455.68158s12.3516,0,17.64514,14.99837,36.17255,66.1693,36.17255,66.1693l17.64515,27.35-12.3516,14.11612-34.408-38.81932-32.64352-53.8177Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M523.07338,785.64579h-24.7032l-5.29355,43.23061s-14.11611,22.93869,7.05806,20.29192,14.11612-26.46772,14.11612-26.46772l5.29354-8.82257,1.76452,18.5274,1.76451-.88226V811.23125S532.77821,802.40868,523.07338,785.64579Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M635.12005,785.64579l-22.93869-1.76451-4.41128,49.40641s-2.64677,18.5274,13.23386,15.88063S631.591,831.52317,631.591,831.52317v-27.35Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M568.50963,373.19052s-12.85305,4.28435-13.5057,21.2042a30.01115,30.01115,0,0,0,.89217,8.03435c.72373,3.0672,1.189,9.66685-4.41983,18.29121a181.06369,181.06369,0,0,0-10.27641,17.67686l-.04021.08042,14.11612,1.76452,3.00156-23.39848a116.515,116.515,0,0,1,9.25236-32.84814l.09768-.21785s6.1758,11.46935,18.5274,11.46935l-4.41128-4.41129s19.40966,7.94031,26.46772,7.94031c0,0,5.29354,3.529,0,8.82258s-15.88063,17.64514-9.70483,27.35.88225,12.3516.88225,12.3516l9.70483-5.29354,4.41129-2.64677v3.529l22.93869-2.64677s6.1758-.88226-7.05806-15.88063c0,0-3.49462-5.82437-1.96569-10.8478a25.33854,25.33854,0,0,0,.96317-11.85005C625.41814,385.12415,613.78618,352.24167,568.50963,373.19052Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M706.47248,591.74916c8.72963-8.8774-.939-27.26315-1.69463-28.66107L605.07538,359.49481a2.596,2.596,0,0,0-4.6629,2.28336L700.16491,565.4725l.028.051c.099.182,9.72559,18.46593,1.15184,23.70465-9.23357,5.64577-20.00163-3.50035-20.10924-3.59337a2.59558,2.59558,0,1,0-3.39362,3.92828c.5565.4811,13.7801,11.69562,26.21089,4.09426A12.57535,12.57535,0,0,0,706.47248,591.74916Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M514.32738,279.88055l73.87332-33.6597s125.15392-47.306,232.21725,68.16875c0,0-47.98254-30.80149-84.35187,9.88562,0,0-68.43748-18.51526-125.8696,49.51461,0,0-89.8273,13.60266-127.23935,61.27357,0,0-43.00714-6.61412-59.06065,48.95392l-2.221-2.184S397.22106,367.50085,514.32738,279.88055Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M514.69194,279.67125s-36.17255,121.75151-31.76126,155.27728",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M552.92157,262.29546s45.58481,102.95475,57.05415,111.77732",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M587.91929,246.14548s117.34022,70.58058,148.21922,78.52089",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M411.50669,832.89852c-.212-.34649-5.21175-8.69467-6.94509-26.02988-1.58988-15.90414-.56756-42.71181,13.33526-80.1063,26.33846-70.84137-6.06985-128.00009-6.401-128.56945l1.59889-.92757c.08392.14437,8.44654,14.7176,13.3867,37.92324a165.44659,165.44659,0,0,1-6.85216,92.218c-26.29335,70.72046-6.74568,104.19892-6.54536,104.52916Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.04295,
    cy: 547.66925,
    r: 12.01157,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.92559,
    cy: 592.01966,
    r: 12.01157,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.05452,
    cy: 621.5866,
    r: 12.01157,
    fill: "#38a7ba"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.46939,
    cy: 646.5337,
    r: 12.01157,
    fill: "#38a7ba"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.81485,
    cy: 685.34031,
    r: 12.01157,
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M418.76307,833.34065s-12.01156-29.56694,24.02314-51.74214Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M403.99071,832.80432s-5.46658-31.442-47.77694-31.1725Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.762 0 234.041 23.132 152.123 77.386 112.936 51.535 191.762 0",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.089 73.493 0 131.572 41.837 156.437 131.892 96.318 90.089 73.493",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M245.83478,79.01991a35.50777,35.50777,0,0,0-19.113,24.204,10.49372,10.49372,0,0,0,3.44177,10.49713l26.04431,21.99527a12.07189,12.07189,0,0,0,13.651,1.3169c10.58913-5.87205,27.59406-18.1986,20.0009-33.80926A10.79238,10.79238,0,0,0,286.1,98.954l-29.0262-19.19415A11.3309,11.3309,0,0,0,245.83478,79.01991Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#d0cde1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.38909,
    cy: 130.98402,
    rx: 42.84102,
    ry: 29.09417,
    transform: "translate(-122.82677 260.14939) rotate(-53.33029)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M288.12757,164.85893c5.28053,3.934,17.83968-3.82122,29.12941-17.57854q1.49993-1.82442,2.96537-3.78865,1.0734-1.443,2.06913-2.88554c10.46805-15.12554,14.60605-29.96212,9.19925-33.98731-5.4465-4.0575-18.62519,4.31143-30.17828,18.87094q-.96769,1.22355-1.91649,2.49625a98.89706,98.89706,0,0,0-6.05725,9.13963C285.89261,149.90734,283.47226,161.3905,288.12757,164.85893Z",
    transform: "translate(-139.16475 -34.35242)",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M293.33871,137.12571,317.257,147.28039l17.11321,7.26465,2.53083-3.41577L322.29148,140.6062l-20.979-15.11637q-.96769,1.22355-1.91649,2.49625A98.89706,98.89706,0,0,0,293.33871,137.12571Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#d0cde1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.8441,
    cy: 120.82018,
    r: 5.19893,
    fill: "#d0cde1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M340.53451,210.09164a2.48185,2.48185,0,0,1,1.17624-.59983c28.00239-5.78582,45.62246-21.9089,53.86527-49.28893a2.49108,2.49108,0,0,1,4.77075,1.43591c-8.6965,28.88662-28.085,46.62787-57.62822,52.73218a2.49139,2.49139,0,0,1-2.184-4.27933Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M333.643,188.41487a2.47686,2.47686,0,0,1,1.17625-.59983c20.99616-4.33861,34.20718-16.42723,40.388-36.95671a2.49108,2.49108,0,0,1,4.77075,1.4359c-6.66287,22.13125-21.51666,35.72308-44.151,40.4a2.49139,2.49139,0,0,1-2.18405-4.27932Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M350.71665,232.28949a2.47682,2.47682,0,0,1,1.17625-.59983c27.945-5.774,58.50393-33.73665,66.72989-61.0606a2.49108,2.49108,0,0,1,4.77075,1.4359c-8.6898,28.86511-40.97163,58.40431-70.49285,64.50385a2.49138,2.49138,0,0,1-2.184-4.27932Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "729.909 0 687.63 23.132 769.547 77.386 808.734 51.535 729.909 0",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "831.582 73.493 921.67 131.572 879.833 156.437 789.779 96.318 831.582 73.493",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M954.16522,79.01991a35.50777,35.50777,0,0,1,19.113,24.204,10.49372,10.49372,0,0,1-3.44177,10.49713l-26.04431,21.99527a12.07189,12.07189,0,0,1-13.651,1.3169c-10.58913-5.87205-27.59406-18.1986-20.0009-33.80926a10.79238,10.79238,0,0,1,3.75978-4.27l29.0262-19.19415A11.3309,11.3309,0,0,1,954.16522,79.01991Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#d0cde1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 898.61091,
    cy: 130.98402,
    rx: 29.09417,
    ry: 42.84102,
    transform: "translate(-39.54578 528.222) rotate(-36.66971)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M911.87243,164.85893c-5.28053,3.934-17.83968-3.82122-29.12941-17.57854q-1.49992-1.82442-2.96537-3.78865-1.0734-1.443-2.06913-2.88554c-10.46805-15.12554-14.606-29.96212-9.19925-33.98731,5.4465-4.0575,18.62519,4.31143,30.17828,18.87094q.96769,1.22355,1.91649,2.49625a98.89706,98.89706,0,0,1,6.05725,9.13963C914.10739,149.90734,916.52774,161.3905,911.87243,164.85893Z",
    transform: "translate(-139.16475 -34.35242)",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M906.66129,137.12571,882.743,147.28039,865.62981,154.545l-2.53083-3.41577,14.60954-10.52307,20.979-15.11637q.96769,1.22355,1.91649,2.49625A98.89706,98.89706,0,0,1,906.66129,137.12571Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#d0cde1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.8264,
    cy: 120.82018,
    r: 5.19893,
    fill: "#d0cde1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M859.46549,210.09164a2.48185,2.48185,0,0,0-1.17624-.59983c-28.00239-5.78582-45.62246-21.9089-53.86527-49.28893a2.49108,2.49108,0,0,0-4.77075,1.43591c8.6965,28.88662,28.085,46.62787,57.62822,52.73218a2.49139,2.49139,0,0,0,2.184-4.27933Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M866.357,188.41487a2.47686,2.47686,0,0,0-1.17625-.59983c-20.99616-4.33861-34.20718-16.42723-40.388-36.95671a2.49108,2.49108,0,0,0-4.77075,1.4359c6.66287,22.13125,21.51666,35.72308,44.151,40.4a2.49139,2.49139,0,0,0,2.184-4.27932Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M849.28335,232.28949a2.47682,2.47682,0,0,0-1.17625-.59983c-27.945-5.774-58.50393-33.73665-66.72989-61.0606a2.49108,2.49108,0,0,0-4.77075,1.4359c8.6898,28.86511,40.97163,58.40431,70.49285,64.50385a2.49138,2.49138,0,0,0,2.184-4.27932Z",
    transform: "translate(-139.16475 -34.35242)",
    fill: "#38a7ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg8);
export default __webpack_public_path__ + "static/media/svg-8.b93584df140a5dad929d49b391afe04d.svg";
export { ForwardRef as ReactComponent };